import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Types
import { ChangeStringValues } from "types/Auth";
import { ProfileState } from "types/ChangePassword";

const initialState: ProfileState = {
  password: "",
  newPassword: "",
  repeatNewPassword: "",
};

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    changeStringField(state, action: PayloadAction<ChangeStringValues>) {
      const { field, value } = action.payload;
      state[field] = value;
    },
    clearnames() {
      return { ...initialState };
    },
  },
});

export const { changeStringField, clearnames } = profileSlice.actions;

export default profileSlice.reducer;
